module.exports = new __parcel__URL__("earthshield.bf8e71ad.png").toString();